import React, { useEffect,useState  } from "react";
import apiUrl from "../../Apiurl";
import CreaHtmlMenu from "./CreaHtmlMenu";


function MenuPStools({
    utente,
    mobile,
    temaColori
}) {
          
/* const [tab, setTab] = useState("creaMenu") */
const [variabili, setVariabili] = useState({});

useEffect(() => {
    //copiare anche qui la stessa cosa che fa la funz da tradurre o non far visualizzare niente
    fetch(apiUrl + "/prodotti/ps/variabili")
        .then(resp => resp.json())
        .then(data => setVariabili(data))
}, []);


///// PAGINA



    return (
        <div className="areaComposizione fr colonnaTuttaPagina">
            <CreaHtmlMenu variabili={variabili} utente={utente}/>
        </div>
    )
}

export default MenuPStools;



